// extracted by mini-css-extract-plugin
export default {"container":"fjamE","schemes":"aAbTu","placeholder":"FlD23","schemeCell":"oJ5e1","schemeImgWrapper":"KY5yi","schemeImg":"r89ot","landscape":"RPJjD","portrait":"qgK3y"};